import ContractType from "./ContractType";

export default {
  TYPE: ContractType,
};
